import { useQuery, gql } from '@apollo/client';

export const GET_NOTIFICATIONS = gql`
  query getNotifications @client {
    notifications @client(always: true) {
      id
      title
      body
      status
    }
  }
`;

export default (options) => {
  return (
    useQuery(GET_NOTIFICATIONS, options)
  );
}
